export default {
    carbonCredit: {
        view: 'Visualizza',
        edit: 'Modifica',
        back: 'Indietro',
        preview: 'Anteprima',
        confirm: 'Conferma',
        cancel: 'Annulla',
        dashboard: 'Dashboard',
        select: 'Seleziona',
        submit: 'Invia',
        save: 'Salva',
        title: 'Credito di Carbonio',
        projects: 'Progetti',
        carbonProjectCredits: 'Crediti di Progetto di Carbonio',
        carbonCreditProjects: 'Progetti di Credito di Carbonio',
        exportAs: 'Esporta come',
        downloadAsCSV: 'Scarica come CSV',
        downloadAsExcel: 'Scarica come Excel',
        downloadAsPDF: 'Scarica come PDF',
        registerNewProject: 'Registra Nuovo Progetto',
        creditInfo: '*Questo è il numero approssimativo di crediti. Il numero effettivo di crediti potrebbe essere diverso dopo la verifica.',
        search: 'Cerca',
        projectTitle: 'Titolo del Progetto',
        projectType: 'Tipo di Progetto',
        country: 'Paese',
        totalCreditsGenerated: 'Totale Crediti Generati',
        status: 'Stato',
        descriptionPlaceholder: "Fornisci una descrizione del progetto includendo gli obiettivi",
        filePreviewNotAvailable: 'L\'anteprima del file non è disponibile per questo tipo di file',
        active: 'Attivo',
        inactive: 'Inattivo',
        pending: 'In Attesa',
        proposed: 'Proposto',
        planned: 'Pianificato',
        inProgress: 'In Corso',
        operational: 'Operativo',
        deactivated: 'Disattivato',
        avoidedDeforestation: 'Deforestazione Evitata',
        agroForestry: 'Agroforestazione',
        forestry: 'Forestazione',
        regenerativeAgriculture: 'Agricoltura Rigenerativa',
        agroforestry: 'Agroforestazione',
        regenerative_agriculture: 'Agricoltura Rigenerativa',
        projectDeletedSuccessfully: 'Progetto disattivato con successo',
        projectUpdatedSuccessfully: 'Progetto aggiornato con successo',
        projectRegisteredSuccessfully: 'Progetto registrato con successo',
        deactivateProjectError: 'Errore durante la disattivazione del progetto',
        deactivate: 'Disattiva',
        deactivateProject: 'Disattiva Progetto',
        deactivateConfirmation: 'Sei sicuro di voler disattivare questo progetto?',
        registerProject: 'Registra un Nuovo Progetto',
        editProject: 'Modifica Progetto',

        register: { 
            title: 'Registra un Progetto',
            editTitle: 'Modifica Progetto',
            projectTitle: 'Titolo del Progetto',
            projectType: 'Tipo di Progetto',
            description: 'Descrizione',
            selectCountry: "Seleziona Paese",
            selectOrganization: 'Seleziona Organizzazioni',
            status: 'Stato',
            creditType: 'Tipo di Credito',
            creditStart: 'Inizio Credito',
            creditEnd: 'Fine Credito',
            standardMethodology: 'Standard/Metodologia',
            validationDocumentation: 'Documentazione di Validazione',
            vintage: 'Annata',
            currency: 'Valuta',
            projectInfo: 'Informazioni del Progetto',
            organizationDetails: 'Dettagli delle Organizzazioni',
            attachmentTitle: 'Allegato(i)',
            attachmentInfo: 'Puoi aggiungere qualsiasi documento aggiuntivo, immagini, video e file audio rilevanti per il progetto',
            documentation: 'Documentazione',
            sdgsTitle: 'Obiettivi di Sviluppo Sostenibile (SDGs)',
            sdgsInfo: 'Seleziona solo gli obiettivi rilevanti per questo progetto specifico. Le organizzazioni avranno accesso per vedere solo gli obiettivi collegati a questo progetto.',
            dataCollectionTitle: 'Ciclo di Raccolta Dati',
            dataCollectionInfo: 'Per partecipare al Programma di Credito di Carbonio, gli agricoltori devono fornire dati storici dell\'azienda durante l\'iscrizione e continuare a inviare aggiornamenti periodici dei dati finché il programma rimane attivo. Questo assicura un monitoraggio accurato delle prestazioni del carbonio nel tempo.',
            vintageYear: 'Anno di Annata',
            estimatedCredit: 'Crediti Stimati',
            pricePerCredit: 'Prezzo Per Credito',
            moduleName: 'Nome del Modulo',
            futureData: 'Raccolta Dati Ricorrenti Future',
            score: 'Punteggio',
            approval: 'Approvazione',

            projectAgreement: 'Accordo del Progetto',
            headerImage: 'Immagine di Intestazione',
            headerImageInfo: '(Dimensione immagine di intestazione 1920 x 420 pixel. L\'immagine predefinita sarà sostituita con la nuova immagine che carichi)',
            headerImagePlaceholder: "Immagine di Intestazione Predefinita",
            responsibleDimitraOffice: 'Ufficio Dimitra Responsabile',
            selectDimitraOffice: 'Seleziona Ufficio Dimitra',
            makeASelection: 'Fai una Selezione',
            addNewDimitraOffice: 'Aggiungi Nuovo Ufficio Dimitra',
            editDimitraOffice: 'Modifica Ufficio Dimitra',
            officeName: 'Nome dell\'Ufficio',
            contactPerson: 'Nome della Persona di Contatto',
            phoneNumber: 'Numero di Telefono',
            email: 'Email',
            address: 'Indirizzo',
            officeNameRequired: 'Il nome dell\'ufficio è richiesto',
            contactPersonRequired: 'Il nome della persona di contatto è richiesto',
            addressRequired: 'L\'indirizzo è richiesto',
            phoneNumberRequired: 'Il numero di telefono è richiesto',
            phoneNumberInvalid: 'Il numero di telefono non è valido',
            phoneNumberLength: 'Il numero di telefono deve essere di almeno 10 cifre',
            selectVintage: 'Seleziona Annata',
            officeAddedSuccessfully: 'Ufficio Dimitra aggiunto con successo',
            errorAddingOffice: 'Errore durante l\'aggiunta dell\'ufficio Dimitra',
            searchOrganizations: 'Cerca Organizzazioni',
            searchOrganizationsPlaceholder: 'Cerca per nome organizzazione...',
            noOrganizationsFound: 'Nessuna organizzazione trovata',
            loadingOrganizations: 'Caricamento organizzazioni...',
            selectedOrganizations: 'Organizzazioni Selezionate',
            errorNegative: 'non può essere negativo.',
            errorRequiredField: '{field} è richiesto.',
            errorOrganizationRequired: 'Almeno un\'organizzazione deve essere selezionata.',
            errorVintageRequired: 'Almeno un\'entrata di annata è richiesta.',
            errorVintageFieldsRequired: 'Tutti i campi dell\'annata (anno, crediti, prezzo) sono richiesti.',
            allOrganizations: 'Tutte le Organizzazioni',
            removal: 'Rimozione',
            avoided: 'Evitato',
            mandatory: 'Obbligatorio',
            scoreValidationError: 'Punteggio non valido per il modulo "{module}". Il punteggio deve essere un numero intero 0 o maggiore.',
            approvalValidationError: 'Approvazione non valida per il modulo "{module}". L\'approvazione deve essere un numero intero tra 0 e 100.',
            saveError: 'Impossibile salvare il progetto',
            fileUploadFailed: 'Caricamento File Fallito',
            unsupportedFileFormat: 'Formato file non supportato',
            errorUploadingFile: 'Errore durante il caricamento del file',
            scoreError: {
                invalid: 'Il punteggio deve essere un numero valido',
                range: 'Il punteggio deve essere 0 o maggiore',
                wholeNumber: 'Il punteggio deve essere un numero intero'
            },
            approvalError: {
                invalid: 'L\'approvazione deve essere un numero valido',
                range: 'L\'approvazione deve essere tra 0 e 100',
                wholeNumber: 'L\'approvazione deve essere un numero intero'
            },
            selectStatus: 'Seleziona Stato',
            selectCreditType: 'Seleziona Tipo di Credito',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standard',
            browse: 'Sfoglia',
            currencyPlaceholder: 'USD',
            selectFile: 'Seleziona File',
            dragDropFiles: 'Trascina e rilascia i file qui',
            hideDetails: 'Nascondi Dettagli',
            viewDetails: 'Visualizza Dettagli',
            website: 'Sito Web',
            month: 'Mese(i)',
            year: 'Anno(i)',
        },

        error: 'Errore',
        success: 'Successo',
        remove: 'Rimuovi',

        projectInfo: {
            title: 'Informazioni del Progetto',
            organizationDetail: 'Dettaglio Organizzazione',
            subOrganizations: 'Sotto-Organizzazioni',
            search: 'Cerca',
            organizations: 'Organizzazioni',
            users: 'Utenti',
            registrationDate: 'Data di Registrazione',
            close: 'Chiudi',
            country: 'Paese',
            organizationsAddress: 'Indirizzo delle Organizzazioni',
            blockchainAddress: 'Indirizzo Blockchain',
            creditType: 'Tipo di Credito',
            projectType: 'Tipo di Progetto',
            officeName: 'Nome dell\'Ufficio',
            contactPersonName: 'Nome della Persona di Contatto',
            contactNumber: 'Numero di Contatto',
            email: 'Email',
            address: 'Indirizzo',
            website: 'Sito Web',
            companyName: 'Nome dell\'Azienda',
            companyAddress: 'Indirizzo dell\'Azienda',
            web: 'Sito Web',
            vintageYear: 'Anno di Annata',
            estimatedCredits: 'Crediti Stimati',
            pricePerCredit: 'Prezzo Per Credito',
            module: 'Modulo',
            recurring: 'Ricorrente',
            score: 'Punteggio',
            approval: 'Approvazione',
            responsibleDimitraOffice: 'Ufficio Dimitra Responsabile',
            status: 'Stato',
            standardMethodology: 'Standard/Metodologia',
            validationDocumentation: 'Documentazione di Validazione',
            creditStart: 'Inizio Credito',
            creditEnd: 'Fine Credito',
            attachmentTitle: 'Allegato(i)',
            sdgsTitle: 'Obiettivi di Sviluppo Sostenibile (SDGs)',
            dataCollectionTitle: 'Ciclo di Raccolta Dati',
            dataCollectionInfo: 'Per partecipare al Programma di Credito di Carbonio, gli agricoltori devono fornire dati storici dell\'azienda durante l\'iscrizione e continuare a inviare aggiornamenti periodici dei dati finché il programma rimane attivo. Questo assicura un monitoraggio accurato delle prestazioni del carbonio nel tempo.',
            vintage: 'Annata',
            moduleName: 'Nome del Modulo',
            futureData: 'Raccolta Dati Ricorrenti Future',
            estimatedCredit: 'Crediti Stimati',
        },

        user: {
            title: 'Utente(i) di Credito di Carbonio',
            selectOrganization: 'Seleziona Organizzazione',
            selectProject: 'Seleziona Progetto',
            allUsers: 'Tutti gli Utenti',
            activeUsers: 'Utenti Attivi',
            deactivatedUsers: 'Utenti Disattivati',
            pendingUsers: 'Utenti in Attesa',
            search: 'Cerca',
            farmerName: 'Nome dell\'Agricoltore',
            farmName: 'Nome dell\'Azienda',
            organizations: 'Organizzazioni',
            country: 'Paese',
            projectTitle: 'Titolo del Progetto',
            registerProject: 'Registra un Nuovo Progetto',
            actions: 'Azioni',
            noData: 'Nessun utente trovato.',
            view: 'Visualizza',
            viewLandPermit: 'Visualizza Titolo di Proprietà / Permesso',
            edit: 'Modifica',
            deactivate: 'Disattiva',
            deactivateUser: 'Disattiva Utente',
            deactivateConfirmation: 'Sei sicuro di voler disattivare questo utente?',
            activate: 'Attiva',
            activateUser: 'Attiva Utente',
            activateConfirmation: 'Sei sicuro di voler attivare questo utente?',
            deactivatedSuccessfully: 'Utente disattivato con successo',
            activatedSuccessfully: 'Utente attivato con successo',
            deactivationFailed: 'Errore durante la disattivazione dell\'utente',
            exportAsPdf: 'Esporta come PDF',
            projectDetails: 'Dettagli del Progetto',
            dateJoined: 'Data di Adesione',
            cropGrowingPractice: 'Pratica di Coltivazione',
            farm: 'Azienda',
            rejectAll: 'RIFIUTA TUTTO',
            acceptAll: 'ACCETTA TUTTO',
            confirmRejectAll: 'Stai per rifiutare le richieste per tutte le aziende di unirsi al progetto di credito di carbonio. Questa azione escluderà ogni azienda inviata dall\'agricoltore in questa richiesta. Sei sicuro di voler continuare?',
            confirmAcceptAll: 'Stai per accettare le richieste per tutte le aziende di unirsi al progetto di credito di carbonio. Questa azione includerà ogni azienda inviata dall\'agricoltore in questa richiesta. Sei sicuro di voler continuare?',
            dateOfRegistration: 'Data di Registrazione',
            farmRegistrationId: 'ID Registrazione Azienda',
            dimitraFarmId: 'ID Azienda Dimitra',
            notTheFarmer: "Non sono l'Agricoltore",
            farmerFirstName: 'Nome dell\'Agricoltore',
            farmerMiddleName: 'Secondo Nome dell\'Agricoltore',
            farmerLastName: 'Cognome dell\'Agricoltore',
            farmerRegistrationId: 'ID Registrazione Agricoltore',
            dimitraFarmerId: 'ID Agricoltore Dimitra',
            farmGeofence: 'Geofence dell\'Azienda',
            viewGeofence: 'Visualizza Geofence',
            totalFarmSize: 'Dimensione Totale dell\'Azienda',
            mainGoals: 'Quali sono i Tuoi Obiettivi Principali',
            ownershipType: 'Tipo di Proprietà',
            certifications: 'Certificazione(i)',
            productionType: 'Tipo di Produzione',
            landTitle: 'Titolo di Proprietà',
            farmLocationAddress: 'Indirizzo di Localizzazione dell\'Azienda',
            farmCoordinate: 'Coordinata dell\'Azienda',
            farmerAgreement: 'Accordo dell\'Agricoltore',
            viewSignedAgreement: 'Visualizza l\'accordo firmato inviato con la domanda.',
            viewAgreement: 'VISUALIZZA ACCORDO',
            acceptanceStatus: 'Stato di Accettazione',
            currentStatus: 'Stato Attuale',
            reject: 'RIFIUTA',
            accept: 'ACCETTA',
            farmActivitySubmissions: 'Invii di Attività dell\'Azienda',
            farmActivitySubmissionsDesc: 'Registri inviati di pratiche agricole e aggiornamenti richiesti per la verifica del credito di carbonio.',
            viewFarmData: 'VISUALIZZA DATI AZIENDA',
            farmData: 'Dati dell\'Azienda',
            farmDataDesc: 'Crea i tuoi rapporti integrando i dati di produzione da varie fonti. Seleziona una o più fonti per compilare un elenco completo dei luoghi di produzione per i tuoi rapporti.',
            crops: 'Colture',
            sowing: 'Semina',
            seedling: 'Semenzale',
            fertilizer: 'Fertilizzante',
            fertilizerError: 'Invio incompleto: Le informazioni sui fertilizzanti per 4 mesi mancano dall\'entrata dell\'agricoltore.',
            harvesting: 'Raccolto',
            livestock: 'Bestiame',
            equipment: 'Attrezzatura',
            projectRequests: 'Richieste di Progetto',
            userNameAndId: 'Nome Utente e ID',
            email: 'Email',
            userRole: 'Ruolo Utente',
            status: 'Stato',
            userRegistrationDate: 'Data Registrazione Utente',
            pending: 'In Attesa',
            deactivated: 'Disattivato',
            active: 'Attivo',
            selectProjectTypeFirst: 'Seleziona il Tipo di Progetto Prima',
            noFarmsToReject: 'Nessuna azienda da rifiutare',
            allFarmsRejected: 'Tutte le aziende rifiutate con successo',
            rejectAllError: 'Impossibile rifiutare tutte le aziende',
            noFarmsToAccept: 'Nessuna azienda da accettare',
            allFarmsAccepted: 'Tutte le aziende accettate con successo',
            acceptAllError: 'Impossibile accettare tutte le aziende',
            farmNotFound: 'Azienda non trovata o non associata al progetto',
            farmAlreadyRejected: 'L\'azienda è già stata rifiutata',
            farmRejected: 'Azienda rifiutata con successo',
            rejectFarmError: 'Impossibile rifiutare l\'azienda',
            farmAlreadyAccepted: 'L\'azienda è già stata accettata',
            farmAccepted: 'Azienda accettata con successo',
            acceptFarmError: 'Impossibile accettare l\'azienda',
        },
        manageTrees: {
            back: 'Indietro',
            treeDetails: 'Dettagli dell\'Albero',
            treeHistory: 'Cronologia dell\'Albero',
            viewHistory: 'Visualizza Cronologia',
            provideUpdates: 'Fornisci Aggiornamenti',
            treeId: 'ID Albero',
            additionalId: 'ID Aggiuntivo',
            programType: 'Tipo di Programma',
            treeImages: 'Immagini dell\'Albero',
            treeImage: 'Immagine dell\'Albero',
            treeQrCode: 'Codice QR dell\'Albero',
            treeAddedBy: 'Albero aggiunto da',
            username: 'Nome utente',
            downloadImage: 'Scarica Immagine',
            dimitraAssetId: 'ID Asset Dimitra',
            zone: 'Zona',
            gpsCoordinates: 'Coordinate GPS',
            locationInformation: 'Informazioni sulla posizione',
            altitude: 'Altitudine',
            seedlingName: 'Nome della piantina',
            treeType: 'Tipo di Albero',
            treeSpecies: 'Specie dell\'Albero',
            dateOfPlantation: 'Data di Piantagione',
            ageOfTree: 'Età dell\'Albero',
            healthCondition: 'Condizione di Salute',
            updatedBy: 'Aggiornato da',
            updatedAt: 'Aggiornato il',
            startDate: 'Data di Inizio',
            endDate: 'Data di Fine',
            additionalNotes: 'Note Aggiuntive',
            whereWouldYouLikeToIncludeThisTree: 'Dove vorresti includere questo albero?',
        },
    }
} 